import React from 'react';
import { motion } from "framer-motion";
export default function StripImageDivider(props) {
    var fields = props.fields;
    return (
    //< !--BEGIN: GENERAL CONTENT-- >
    React.createElement(motion.div, { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip sky23-image-divider container-fluid gx-0 "
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("div", { className: "row flex-column" },
                    React.createElement("div", { className: "col col-auto" }, fields.backgroundImage &&
                        React.createElement("img", { src: fields.backgroundImage, alt: fields.backgroundImage_description ? fields.backgroundImage_description : "", className: "img-fluid w-100", width: "100%", title: "Pebbles" })))))));
}
